import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Grid,
  Chip,
  Avatar,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const medalColors = ['#FFD700', '#C0C0C0', '#CD7F32'];

const IndicadorRankingModal = ({ 
  open, 
  onClose, 
  rankingData = [], 
  indicador,
  tipoOrdenacao = 'maior-melhor' // 'maior-melhor' ou 'menor-melhor'
}) => {
  const getIndicadorValor = (indicadores) => {
    if (indicadores && typeof indicadores[indicador] === 'number') {
      return indicadores[indicador];
    }
    return null;
  };

  const sorted = [...rankingData]
    .filter(item => {
      const valor = getIndicadorValor(item.indicadores);
      return typeof valor === 'number' && !isNaN(valor);
    })
    .sort((a, b) => {
      const valorA = getIndicadorValor(a.indicadores);
      const valorB = getIndicadorValor(b.indicadores);
      if (tipoOrdenacao === 'menor-melhor') {
        return valorA - valorB;
      }
      return valorB - valorA;
    });

  const top5 = sorted.slice(0, 5);
  const bottom5 = sorted.slice(-5).reverse();

  const formatValor = (valor) => {
    if (indicador.includes('Tempo')) {
      return `${valor.toFixed(2)} min`;
    }
    if (indicador.includes('%') || indicador === 'Aderência de Turno') {
      return `${valor.toFixed(2)}%`;
    }
    return valor;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 4, p: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmojiEventsIcon color="warning" />
          <Typography variant="h6" fontWeight={700}>Ranking de {indicador}</Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, color: 'success.main' }}>
              {tipoOrdenacao === 'menor-melhor' ? '5 Melhores (menor tempo)' : '5 Melhores'}
            </Typography>
            {top5.length === 0 && <Typography color="text.secondary">Sem dados</Typography>}
            {top5.map((item, idx) => (
              <Box key={item.num_contrato} sx={{ display: 'flex', alignItems: 'center', mb: 1.5, p: 1, borderRadius: 2, bgcolor: idx === 0 ? 'success.lighter' : 'background.paper', boxShadow: idx === 0 ? 2 : 0 }}>
                <Avatar sx={{ bgcolor: medalColors[idx] || 'success.main', mr: 2, width: 36, height: 36, fontWeight: 700 }}>
                  {idx < 3 ? <EmojiEventsIcon /> : idx + 1}
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography fontWeight={600}>{item.num_contrato}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {indicador}: <b>{formatValor(getIndicadorValor(item.indicadores))}</b>
                  </Typography>
                </Box>
                <Chip label={`#${idx + 1}`} color="success" size="small" />
              </Box>
            ))}
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, color: 'error.main' }}>
              {tipoOrdenacao === 'menor-melhor' ? '5 Piores (maior tempo)' : '5 Piores'}
            </Typography>
            {bottom5.length === 0 && <Typography color="text.secondary">Sem dados</Typography>}
            {bottom5.map((item, idx) => {
              const originalIndex = sorted.length - 1 - idx;
              return (
                <Box key={item.num_contrato} sx={{ display: 'flex', alignItems: 'center', mb: 1.5, p: 1, borderRadius: 2, bgcolor: idx === 0 ? 'error.lighter' : 'background.paper', boxShadow: idx === 0 ? 2 : 0 }}>
                  <Avatar sx={{ bgcolor: idx === 0 ? 'error.main' : 'grey.400', mr: 2, width: 36, height: 36, fontWeight: 700 }}>
                    <SentimentVeryDissatisfiedIcon />
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography fontWeight={600}>{item.num_contrato}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {indicador}: <b>{formatValor(getIndicadorValor(item.indicadores))}</b>
                    </Typography>
                  </Box>
                  <Chip label={`#${originalIndex + 1}`} color="error" size="small" />
                </Box>
              );
            })}
          </Grid>
        </Grid>
        <Divider sx={{ mt: 3 }} />
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Os valores são baseados no ranking de {indicador} {tipoOrdenacao === 'menor-melhor' ? '(menor = melhor)' : '(maior = melhor)'} entre todos os contratos.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default IndicadorRankingModal;